import { initTabs } from "../../../src/js/modules/tabs";
import { initOnScrollAnimation } from "../../../src/js/modules/on-scroll-animations";
import { initAccordions } from "../../../src/js/modules/accordion";

document.querySelectorAll(".js-server-modules").forEach((el) => {
	initTabs(el);
	initAccordions(el);
	initOnScrollAnimation(el);
});
